export default function InfiniteScroll($rootScope) {
    'ngInject';

    return {
        link: function(scope, elem, attrs) {
            const scrollDistance = scope.$eval(attrs.ktTypeaheadDropdownInfiniteScrollDistance);

            elem.on('scroll', scrollHandler);
            scope.$on('$destroy', function() {
                return elem.off('scroll', scrollHandler);
            });

            function scrollHandler() {
                const container = angular.element(elem.children()[0]);
                const elementBottom = elem.offset().top + elem.height();
                const containerBottom = container.offset().top + container.height();
                const remaining = containerBottom - elementBottom;
                const shouldScroll = remaining <= elem.height() * scrollDistance;
                if (shouldScroll) {
                    if ($rootScope.$$phase) {//eslint-disable-line
                        return scope.$eval(attrs.ktTypeaheadDropdownInfiniteScroll);
                    }
                    return scope.$apply(attrs.ktTypeaheadDropdownInfiniteScroll);
                }
            }
        },
    };
}



// WEBPACK FOOTER //
// ./src/app/modules/common/typeahead-dropdown/typeahead-dropdown-infinite-scroll.js